import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";

import HttpManager from "../../../../services/HttpManager";
import { Audio, Did, Ivr } from "../../../../services/v2/telefonia.service";
import { Aviso, Check, cuando, DestinoSelect, destinoTexto, errorTexto, HorarioEditor, plantelNombre, telBonito } from "./comunes";
import { Compartido } from "./telefoniaController";

const DIAS_T: Record<string, string> = { 1: "L", 2: "M", 3: "Mi", 4: "J", 5: "V", 6: "S", 7: "D" };
const horarioTexto = (h: any): string => !h ? "Siempre" : Object.entries(h.dias).map(([d, r]: any) => DIAS_T[d] + " " + r.map((x: any) => x[0] + "–" + x[1]).join(", ")).join(" · ");

/**
 * Recepción: qué pasa cuando alguien llama. Números (cada número a su destino, con horario y mensaje de fuera de
 * horario), recepcionistas (saludo + "marque 1 para…") y los audios (grabados aquí mismo o subidos).
 */
const Recepcion: React.FC<{ sh: Compartido }> = ({ sh }) => {
	const http = HttpManager.getInstance();
	const [numeros, setNumeros] = useState<Did[]>([]);
	const [editNum, setEditNum] = useState<any | null>(null);
	const [editIvr, setEditIvr] = useState<any | null>(null);
	const [subir, setSubir] = useState<boolean>(false);
	const [oyendo, setOyendo] = useState<{ id: number; url: string } | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [aviso, setAviso] = useState<string | null>(null);
	const cargarNumeros = () => http.telefoniaService.numeros(sh.campusId).then((r) => setNumeros(r.data.numeros)).catch((e) => setError(errorTexto(e)));
	useEffect(() => { cargarNumeros(); }, [sh.campusId]);

	const borrarNumero = async (n: Did) => {
		if (!window.confirm("¿Borrar el número " + n.label + "? Las llamadas a ese número caerán en el primer número de la lista.")) return;
		try { setNumeros((await http.telefoniaService.borrarNumero(sh.campusId, n.id)).data.numeros); } catch (e) { setError(errorTexto(e)); }
	};
	const borrarIvr = async (i: Ivr) => {
		if (!window.confirm("¿Borrar la recepcionista " + i.name + "?")) return;
		try { sh.setIvrs((await http.telefoniaService.borrarIvr(sh.campusId, i.id)).data.recepcionistas); } catch (e) { setError(errorTexto(e)); }
	};
	const borrarAudio = async (a: Audio) => {
		if (!window.confirm("¿Borrar el audio " + a.name + "?")) return;
		try { sh.setAudios((await http.telefoniaService.borrarAudio(sh.campusId, a.id)).data.audios); } catch (e) { setError(errorTexto(e)); }
	};
	const oir = async (a: Audio) => {
		if (oyendo?.id === a.id) return setOyendo(null);
		try { const r = await http.telefoniaService.archivoAudio(sh.campusId, a.id); setOyendo({ id: a.id, url: URL.createObjectURL(r.data) }); } catch (e) { setError(errorTexto(e)); }
	};
	const nombreAudio = (id: number | null | undefined) => sh.audios.find((a) => a.id === id)?.name || "sin audio";

	return (
		<>
			<Aviso texto={error} onClose={() => setError(null)} /><Aviso texto={aviso} tipo="ok" onClose={() => setAviso(null)} />
			<div className="nu-bloque" style={{ marginBottom: 14 }}>
				<div className="nu-bloque-tit">Números que entran <button className="nu-btn pri chico" onClick={() => setEditNum({ number: "", label: "", campus_id: sh.cat.planteles[0]?.id ?? "", trunk: "", route: sh.ivrs[0] ? { type: "ivr", target: String(sh.ivrs[0].id) } : sh.colas[0] ? { type: "queue", target: sh.colas[0].code } : { type: "extension", target: sh.extensiones[0]?.extension || "" }, horario: null, fuera_horario: { audio_id: null, type: "hangup", target: "" }, bool_outbound_default: false, bool_enabled: true })}>+ Agregar número</button></div>
				<span className="nu-tenue">Cada número de teléfono de la empresa (el que marcan los clientes) y a dónde va la llamada. El marcado como "principal" es el que ven los clientes cuando el plantel llama.</span>
				<div className="tf-lista">
					{numeros.map((n) => (
						<div key={n.id} className={"tf-item" + (n.bool_enabled ? "" : " apagado")}>
							<div>
								<h4>{telBonito(n.number)} <span className="nu-tenue">· {n.label} · {plantelNombre(sh.cat, n.campus_id)}</span>{n.bool_outbound_default ? <span className="tf-chip ok" style={{ marginLeft: 8 }}>principal del plantel</span> : null}</h4>
								<div className="tf-desc"><b>Va a:</b> {destinoTexto(n.route, sh.colas, sh.ivrs, sh.extensiones, sh.audios)}{n.trunk ? <span className="nu-tenue"> · entra por {n.trunk}</span> : null}</div>
								<div className="tf-desc"><b>Horario:</b> {horarioTexto(n.horario)}{n.horario ? <> · <b>Fuera de horario:</b> {n.fuera_horario?.audio_id ? "suena " + nombreAudio(n.fuera_horario.audio_id) + ", luego " : ""}{destinoTexto(n.fuera_horario as any, sh.colas, sh.ivrs, sh.extensiones, sh.audios).toLowerCase()}</> : null}</div>
							</div>
							<div className="tf-acciones"><button className="nu-btn chico" onClick={() => setEditNum({ ...n, fuera_horario: n.fuera_horario || { audio_id: null, type: "hangup", target: "" } })}>Editar</button><button className="nu-btn chico" onClick={() => borrarNumero(n)}>Borrar</button></div>
						</div>
					))}
					{!numeros.length ? <div className="nu-vacio">Sin números todavía. Agrega los números de cada plantel cuando el proveedor los conecte a la central.</div> : null}
				</div>
			</div>
			<div className="tf-rejilla">
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Recepcionistas <button className="nu-btn pri chico" onClick={() => setEditIvr({ name: "", audio_id: sh.audios[0]?.id || null, options: [], timeout_seconds: 5, retries: 2, timeout_action: sh.colas[0] ? { type: "queue", target: sh.colas[0].code } : null, invalid_audio_id: null, bool_enabled: true })}>+ Nueva</button></div>
					<span className="nu-tenue">Un saludo y, si quieres, "marque 1 para Ventas, 2 para Caja…". Sin opciones, saluda y pasa la llamada.</span>
					<div className="tf-lista">
						{sh.ivrs.map((i) => (
							<div key={i.id} className={"tf-item" + (i.bool_enabled ? "" : " apagado")}>
								<div>
									<h4>{i.name}</h4>
									<div className="tf-desc"><b>Saludo:</b> {nombreAudio(i.audio_id)}</div>
									{i.options.length ? <div className="tf-desc">{i.options.map((o) => <div key={o.digit}><b>{o.digit}</b> → {o.label ? o.label + ": " : ""}{destinoTexto(o, sh.colas, sh.ivrs, sh.extensiones, sh.audios)}</div>)}</div> : null}
									<div className="tf-desc"><b>{i.options.length ? "Si no marca nada" : "Después del saludo"}:</b> {destinoTexto(i.timeout_action || i.options[0], sh.colas, sh.ivrs, sh.extensiones, sh.audios)}</div>
								</div>
								<div className="tf-acciones"><button className="nu-btn chico" onClick={() => setEditIvr({ ...i })}>Editar</button><button className="nu-btn chico" onClick={() => borrarIvr(i)}>Borrar</button></div>
							</div>
						))}
						{!sh.ivrs.length ? <div className="nu-vacio">Crea una con el saludo "Gracias por llamar a Washington Academy…" y mándala a un departamento.</div> : null}
					</div>
				</div>
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Audios <button className="nu-btn pri chico" onClick={() => setSubir(true)}>+ Grabar o subir</button></div>
					<span className="nu-tenue">Se graban aquí mismo con el micrófono o se sube un MP3/WAV. La central los convierte sola.</span>
					<div className="tf-lista">
						{sh.audios.map((a) => (
							<div key={a.id} className="tf-item">
								<div>
									<h4>{a.name} <span className="tf-chip">{sh.cat.audio_kinds[a.kind] || a.kind}</span></h4>
									<div className="tf-meta"><span>{a.source === "grabado" ? "Grabado en WAPP" : "Subido"} · {Math.round(a.bytes / 1024)} KB · {a.created_by_name || ""} · {cuando(a.created_at)}</span></div>
									{oyendo?.id === a.id ? <div className="tf-audio" style={{ marginTop: 6 }}><audio controlsList="nodownload" controls autoPlay src={oyendo.url} /></div> : null}
								</div>
								<div className="tf-acciones"><button className="nu-btn chico" onClick={() => oir(a)}>{oyendo?.id === a.id ? "Cerrar" : "▶ Oír"}</button><button className="nu-btn chico" onClick={() => borrarAudio(a)}>Borrar</button></div>
							</div>
						))}
						{!sh.audios.length ? <div className="nu-vacio">Sin audios. Graba el saludo: "Gracias por llamar a Washington Academy. En unos momentos te comunicamos con una asesora."</div> : null}
					</div>
				</div>
			</div>
			{editNum ? <EditorNumero sh={sh} v0={editNum} onClose={() => setEditNum(null)} onHecho={(ns) => { setNumeros(ns); setEditNum(null); setAviso("Número guardado. La central lo toma en un minuto."); }} /> : null}
			{editIvr ? <EditorIvr sh={sh} v0={editIvr} onClose={() => setEditIvr(null)} onHecho={(is) => { sh.setIvrs(is); setEditIvr(null); setAviso("Recepcionista guardada. La central la toma en un minuto."); }} /> : null}
			{subir ? <SubirAudio sh={sh} onClose={() => setSubir(false)} onHecho={(as) => { sh.setAudios(as); setSubir(false); setAviso("Audio guardado. La central lo baja en un minuto."); }} /> : null}
		</>
	);
};

const EditorNumero: React.FC<{ sh: Compartido; v0: any; onClose: () => void; onHecho: (n: Did[]) => void }> = ({ sh, v0, onClose, onHecho }) => {
	const http = HttpManager.getInstance();
	const [v, setV] = useState<any>(v0);
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const set = (k: string, x: any) => setV({ ...v, [k]: x });
	const guardar = async () => {
		setBusy(true); setError(null);
		try { onHecho((await http.telefoniaService.guardarNumero(sh.campusId, v.id || null, v)).data.numeros); } catch (e) { setError(errorTexto(e)); } finally { setBusy(false); }
	};
	const dest = { colas: sh.colas, ivrs: sh.ivrs, extensiones: sh.extensiones, audios: sh.audios, equipos: sh.cat.equipos };
	return (
		<Modal show onHide={onClose} size="lg" className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>{v.id ? "Editar número" : "Agregar número"}</Modal.Title></Modal.Header>
			<Modal.Body className="tf">
				<div className="cp-dos">
					<div><label>Número con lada</label><input type="text" placeholder="504 2234 5678" value={v.number} onChange={(e) => set("number", e.target.value)} autoFocus /></div>
					<div><label>Nombre</label><input type="text" placeholder="Tegucigalpa principal" value={v.label} onChange={(e) => set("label", e.target.value)} /></div>
					<div><label>Plantel</label><select value={v.campus_id ?? ""} onChange={(e) => set("campus_id", e.target.value ? Number(e.target.value) : "")}>{sh.cat.super ? <option value="">Sin plantel</option> : null}{sh.cat.planteles.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></div>
					<div><label>Entra por (troncal, opcional)</label><input type="text" placeholder="claro" value={v.trunk || ""} onChange={(e) => set("trunk", e.target.value)} /></div>
				</div>
				<div className="tf-campo" style={{ marginTop: 10 }}><label>Cuando llaman a este número, la llamada va a</label><DestinoSelect value={v.route} onChange={(d) => set("route", d)} {...dest} sin={["hangup"]} /></div>
				<div style={{ marginTop: 10 }}><HorarioEditor value={v.horario} onChange={(h) => set("horario", h)} zonas={sh.cat.zonas} /></div>
				{v.horario ? (
					<div className="cp-dos" style={{ marginTop: 10 }}>
						<div><label>Fuera de horario: primero suena</label><select value={v.fuera_horario?.audio_id || ""} onChange={(e) => set("fuera_horario", { ...v.fuera_horario, audio_id: e.target.value ? Number(e.target.value) : null })}><option value="">— ningún audio —</option>{sh.audios.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></div>
						<div><label>…y luego</label><DestinoSelect value={v.fuera_horario?.type ? { type: v.fuera_horario.type, target: v.fuera_horario.target || "" } : { type: "hangup", target: "" }} onChange={(d) => set("fuera_horario", { ...v.fuera_horario, ...(d || { type: "hangup", target: "" }) })} {...dest} /></div>
					</div>
				) : null}
				<div style={{ display: "flex", gap: 16, marginTop: 10, flexWrap: "wrap" }}>
					<Check checked={!!v.bool_outbound_default} onChange={(b) => set("bool_outbound_default", b)}>Es el número principal del plantel (lo ven los clientes al recibir llamadas)</Check>
					<Check checked={!!v.bool_enabled} onChange={(b) => set("bool_enabled", b)}>Activo</Check>
				</div>
				{error ? <Aviso texto={error} /> : null}
			</Modal.Body>
			<Modal.Footer><button className="nu-btn" onClick={onClose}>Cancelar</button><button className="nu-btn pri" disabled={busy || !v.number.trim()} onClick={guardar}>Guardar</button></Modal.Footer>
		</Modal>
	);
};

const EditorIvr: React.FC<{ sh: Compartido; v0: any; onClose: () => void; onHecho: (i: Ivr[]) => void }> = ({ sh, v0, onClose, onHecho }) => {
	const http = HttpManager.getInstance();
	const [v, setV] = useState<any>(v0);
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const set = (k: string, x: any) => setV({ ...v, [k]: x });
	const dest = { colas: sh.colas, ivrs: sh.ivrs.filter((i) => i.id !== v.id), extensiones: sh.extensiones, audios: sh.audios, equipos: sh.cat.equipos };
	const setOpt = (i: number, o: any) => set("options", v.options.map((x: any, j: number) => (j === i ? { ...x, ...o } : x)));
	const libres = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "*", "#"].filter((d) => !v.options.some((o: any) => o.digit === d));
	const guardar = async () => {
		setBusy(true); setError(null);
		try { onHecho((await http.telefoniaService.guardarIvr(sh.campusId, v.id || null, v)).data.recepcionistas); } catch (e) { setError(errorTexto(e)); } finally { setBusy(false); }
	};
	return (
		<Modal show onHide={onClose} size="lg" className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>{v.id ? "Editar recepcionista" : "Nueva recepcionista"}</Modal.Title></Modal.Header>
			<Modal.Body className="tf">
				<div className="cp-dos">
					<div><label>Nombre</label><input type="text" placeholder="Bienvenida Tegucigalpa" value={v.name} onChange={(e) => set("name", e.target.value)} autoFocus /></div>
					<div><label>Saludo (audio)</label><select value={v.audio_id || ""} onChange={(e) => set("audio_id", e.target.value ? Number(e.target.value) : null)}><option value="">— sin saludo —</option>{sh.audios.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></div>
				</div>
				<div className="tf-campo" style={{ marginTop: 10 }}><label>Opciones ("marque 1 para…") — vacío = solo saluda y pasa</label>
					<div className="tf-opciones">
						{v.options.map((o: any, i: number) => (
							<div key={i} className="tf-opcion">
								<select value={o.digit} onChange={(e) => setOpt(i, { digit: e.target.value })}>{[o.digit, ...libres].map((d) => <option key={d} value={d}>{d}</option>)}</select>
								<input type="text" placeholder="Etiqueta (Ventas)" value={o.label || ""} onChange={(e) => setOpt(i, { label: e.target.value })} />
								<DestinoSelect value={o} onChange={(d) => setOpt(i, d || { type: "hangup", target: "" })} {...dest} />
								<button type="button" className="tf-x" onClick={() => set("options", v.options.filter((_: any, j: number) => j !== i))} aria-label="Quitar opción">×</button>
							</div>
						))}
						{libres.length ? <div><button className="nu-btn chico" onClick={() => set("options", [...v.options, { digit: libres[0], label: "", type: "queue", target: sh.colas[0]?.code || "" }])}>+ Opción</button></div> : null}
					</div>
				</div>
				<div className="cp-dos" style={{ marginTop: 10 }}>
					<div><label>{v.options.length ? "Si no marca nada, va a" : "Después del saludo, va a"}</label><DestinoSelect value={v.timeout_action} onChange={(d) => set("timeout_action", d)} {...dest} permitirVacio={!!v.options.length} vacioTexto="la primera opción" /></div>
					{v.options.length ? <div><label>Si marca algo inválido, suena</label><select value={v.invalid_audio_id || ""} onChange={(e) => set("invalid_audio_id", e.target.value ? Number(e.target.value) : null)}><option value="">— "opción inválida" de la central —</option>{sh.audios.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></div> : null}
					{v.options.length ? <div><label>Segundos para marcar</label><input type="number" min={2} max={20} value={v.timeout_seconds} onChange={(e) => set("timeout_seconds", Number(e.target.value))} /></div> : null}
					{v.options.length ? <div><label>Intentos antes de pasar</label><input type="number" min={1} max={5} value={v.retries} onChange={(e) => set("retries", Number(e.target.value))} /></div> : null}
				</div>
				<div style={{ marginTop: 10 }}><Check checked={!!v.bool_enabled} onChange={(b) => set("bool_enabled", b)}>Activa</Check></div>
				{error ? <Aviso texto={error} /> : null}
			</Modal.Body>
			<Modal.Footer><button className="nu-btn" onClick={onClose}>Cancelar</button><button className="nu-btn pri" disabled={busy || !v.name.trim()} onClick={guardar}>Guardar</button></Modal.Footer>
		</Modal>
	);
};

/** Grabar con el micrófono (MediaRecorder) o subir un archivo. */
const SubirAudio: React.FC<{ sh: Compartido; onClose: () => void; onHecho: (a: Audio[]) => void }> = ({ sh, onClose, onHecho }) => {
	const http = HttpManager.getInstance();
	const [name, setName] = useState<string>("");
	const [kind, setKind] = useState<string>("saludo");
	const [reemplaza, setReemplaza] = useState<string>("");
	const [archivo, setArchivo] = useState<File | null>(null);
	const [grabando, setGrabando] = useState<boolean>(false);
	const [blob, setBlob] = useState<Blob | null>(null);
	const [url, setUrl] = useState<string | null>(null);
	const [segundos, setSegundos] = useState<number>(0);
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const rec = useRef<any>(null);
	const trozos = useRef<Blob[]>([]);
	const reloj = useRef<any>(null);

	const empezar = async () => {
		const MR: any = (window as any).MediaRecorder;
		if (!navigator.mediaDevices?.getUserMedia || !MR) return setError("Este navegador no puede grabar audio.");
		try {
			const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
			const mime = MR.isTypeSupported?.("audio/webm;codecs=opus") ? "audio/webm;codecs=opus" : MR.isTypeSupported?.("audio/mp4") ? "audio/mp4" : "";
			const r = new MR(stream, mime ? { mimeType: mime } : undefined);
			trozos.current = [];
			r.ondataavailable = (e: any) => { if (e.data.size) trozos.current.push(e.data); };
			r.onstop = () => {
				stream.getTracks().forEach((t) => t.stop());
				const b = new Blob(trozos.current, { type: r.mimeType || "audio/webm" });
				setBlob(b); setUrl(URL.createObjectURL(b)); setArchivo(null);
			};
			r.start(250); rec.current = r; setGrabando(true); setSegundos(0);
			reloj.current = setInterval(() => setSegundos((s) => s + 1), 1000);
		} catch (e) { setError("No se pudo usar el micrófono. Revisa el permiso del navegador."); }
	};
	const parar = () => { rec.current?.stop(); setGrabando(false); clearInterval(reloj.current); };
	useEffect(() => () => { clearInterval(reloj.current); if (url) URL.revokeObjectURL(url); }, []);
	const guardar = async () => {
		const f = archivo || (blob ? new File([blob], "grabacion." + (blob.type.includes("mp4") ? "m4a" : "webm"), { type: blob.type }) : null);
		if (!f) return;
		setBusy(true); setError(null);
		try {
			const fd = new FormData();
			fd.append("audio", f); fd.append("name", name || (archivo ? archivo.name.replace(/\.[^.]+$/, "") : "Grabación")); fd.append("kind", kind); fd.append("source", archivo ? "subido" : "grabado");
			if (reemplaza) fd.append("reemplaza", reemplaza);
			onHecho((await http.telefoniaService.subirAudio(sh.campusId, fd)).data.audios);
		} catch (e) { setError(errorTexto(e)); } finally { setBusy(false); }
	};
	return (
		<Modal show onHide={onClose} className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>Grabar o subir audio</Modal.Title></Modal.Header>
			<Modal.Body className="tf">
				<div className="cp-dos">
					<div><label>Nombre</label><input type="text" placeholder="Saludo Tegucigalpa" value={name} onChange={(e) => setName(e.target.value)} autoFocus /></div>
					<div><label>Para qué es</label><select value={kind} onChange={(e) => setKind(e.target.value)}>{Object.entries(sh.cat.audio_kinds).map(([k, t]) => <option key={k} value={k}>{t}</option>)}</select></div>
					{sh.audios.length ? <div><label>Reemplaza a (opcional)</label><select value={reemplaza} onChange={(e) => setReemplaza(e.target.value)}><option value="">— es uno nuevo —</option>{sh.audios.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></div> : null}
				</div>
				<div className="nu-bloque" style={{ marginTop: 12 }}>
					<div className="nu-bloque-tit chico">Grabar con el micrófono</div>
					<div className="tf-grabar">
						{!grabando ? <button className="nu-btn pri" onClick={empezar}>● Grabar</button> : <button className="nu-btn" onClick={parar}>■ Detener</button>}
						{grabando ? <span><i className="rec" /> {segundos} s</span> : null}
						{url && !grabando ? <audio controls src={url} /> : null}
					</div>
					<span className="nu-tenue">Habla claro y a volumen normal. Ejemplo: "Gracias por llamar a Washington Academy. En unos momentos te comunicamos con una asesora."</span>
				</div>
				<div className="nu-bloque" style={{ marginTop: 12 }}>
					<div className="nu-bloque-tit chico">…o subir un archivo</div>
					<input type="file" accept="audio/*,.mp3,.wav,.m4a,.ogg" onChange={(e) => { setArchivo(e.target.files?.[0] || null); setBlob(null); setUrl(null); }} />
				</div>
				{error ? <Aviso texto={error} /> : null}
			</Modal.Body>
			<Modal.Footer><button className="nu-btn" onClick={onClose}>Cancelar</button><button className="nu-btn pri" disabled={busy || grabando || (!archivo && !blob)} onClick={guardar}>Guardar audio</button></Modal.Footer>
		</Modal>
	);
};

export default Recepcion;
